import * as React from 'react';
import { ILinks3Data } from '../obrien-ff.props.autogenerated';

export interface IContentCardLinks3 {
    links3: ILinks3Data[];
}

const ContentCardLinks3: React.FC<IContentCardLinks3> = ({ links3 }) => (
    <div className='ms-content-block__cta'>
        {links3.map((cta: ILinks3Data, index: number) => {
            const btnClass = index === 0 ? 'msc-cta__primary' : 'msc-cta__secondary';
            return <a
                key={`link-${index}`}
                className={btnClass}
                role='button'
                title={cta.linkText}
                href={cta.linkUrl && cta.linkUrl.destinationUrl}
                aria-label={cta.ariaLabel}
                target={cta.openInNewTab ? '_blank' : undefined}
            >
                <span>{cta.linkText}</span>
            </a>;
        })}
    </div>
);

export default ContentCardLinks3;